import { atom } from 'recoil';

export const confettiAtom = atom({
  key: 'confettiState',
  default: false
});
